document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-bw-tracking-widget]').forEach(function (widget) {
    const input = widget.querySelector('[data-tracking-number]');
    const button = widget.querySelector('[data-track-button]');
    const status = widget.querySelector('[data-tracking-status]');
    const results = widget.querySelector('[data-tracking-results]');

    if (!input || !button || !status || !results) return;

    let trackingScriptPromise;

    function loadTrackingScript() {
      if (window.YQV5) return Promise.resolve();
      if (trackingScriptPromise) return trackingScriptPromise;

      trackingScriptPromise = new Promise(function (resolve, reject) {
        const script = document.createElement('script');
        script.src = 'https://www.17track.net/externalcall.js';
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });

      return trackingScriptPromise;
    }

    async function trackOrder() {
      const trackingNumber = input.value.trim();

      if (!trackingNumber) {
        status.textContent = 'Please enter your tracking number.';
        input.focus();
        return;
      }

      button.disabled = true;
      status.textContent = 'Loading tracking information…';

      try {
        await loadTrackingScript();

        if (!window.YQV5 || typeof window.YQV5.trackSingle !== 'function') {
          throw new Error('Tracking service is unavailable.');
        }

        status.textContent = '';

        window.YQV5.trackSingle({
          YQ_ContainerId: results.id || (results.id = 'YQContainer-' + Math.random().toString(36).slice(2)),
          YQ_Height: 560,
          YQ_Fc: '0',
          YQ_Lang: 'en',
          YQ_Num: trackingNumber
        });
      } catch (error) {
        status.textContent = 'Tracking could not be loaded. Please try again or contact our support team.';
      } finally {
        button.disabled = false;
      }
    }

    button.addEventListener('click', trackOrder);

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        trackOrder();
      }
    });
  });
});